"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vuex = require("vuex");
var _Page = _interopRequireDefault(require("@/ui/layout/Page"));
var _DialogAlert = _interopRequireDefault(require("@/ui/components/DialogAlert"));
var _CardSendEmail = _interopRequireDefault(require("./components/CardSendEmail"));
var _CardAmount = _interopRequireDefault(require("./components/CardAmount"));
var _CardQrcode = _interopRequireDefault(require("./components/CardQrcode"));
var _ListItemCheck = _interopRequireDefault(require("./components/ListItemCheck"));
var _ListReportsTags = _interopRequireDefault(require("./components/ListReportsTags"));
var _NoRecordFound = _interopRequireDefault(require("@/ui/components/NoRecordFound"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _default = exports.default = {
  name: 'Identifiers',
  components: {
    Page: _Page.default,
    CardAmount: _CardAmount.default,
    CardQrcode: _CardQrcode.default,
    ListItemCheck: _ListItemCheck.default,
    NoRecordFound: _NoRecordFound.default,
    ListReportsTags: _ListReportsTags.default,
    CardSendEmail: _CardSendEmail.default
  },
  data: function data() {
    return {
      emailDownload: null,
      activeTab: 0,
      amount: null,
      listPrint: [],
      pageCurrent: 1,
      perPage: 12,
      rangeBefore: 3,
      rangeAfter: 1,
      prevIcon: 'chevron-left',
      nextIcon: 'chevron-right',
      checkAll: false,
      generateIsFlag: false,
      checkFlag: true,
      checkIndividual: true,
      intervalid: null
    };
  },
  computed: _objectSpread(_objectSpread({}, (0, _vuex.mapGetters)({
    menuItems: 'menuItemsFarm',
    isLoading: 'isLoading',
    identifiersList: 'identifiersList'
  })), {}, {
    listFiltered: function listFiltered() {
      if (!this.checkFlag) {
        if (!this.checkIndividual) {
          return [];
        }
        return this.identifiersList.data.filter(function (item) {
          return item && !item.groupId;
        });
      } else {
        if (this.checkIndividual) {
          return this.identifiersList.data;
        }
        return this.identifiersList.data.filter(function (item) {
          return item && item.groupId;
        });
      }
    }
  }),
  created: function created() {
    this.fetchAllIdentifiers(this.pageCurrent);
    this.loopRecursive();
  },
  watch: {
    pageCurrent: function pageCurrent(val) {
      this.fetchAllIdentifiers(val);
    },
    checkAll: function checkAll(val) {
      if (val) {
        this.allCheckedOption();
      } else this.allCheckedOption('markOff');
    },
    identifiersList: function identifiersList(val) {
      if (this.checkAll) {
        this.allCheckedOption();
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.intervalid);
  },
  methods: _objectSpread(_objectSpread({}, (0, _vuex.mapActions)(['fetchAllIdentifiers', 'generateIdentifiers', 'deleteInventory', 'setLoading', 'downloadTagsIdentifiers'])), {}, {
    loopRecursive: function () {
      var _loopRecursive = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this = this;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this.intervalid = setInterval(function () {
                _this.fetchAllIdentifiers(_this.pageCurrent);
              }, 60000);
            case 1:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function loopRecursive() {
        return _loopRecursive.apply(this, arguments);
      }
      return loopRecursive;
    }(),
    generateFlag: function generateFlag(item) {
      this.generateIsFlag = item;
    },
    verifyGenerateCodes: function verifyGenerateCodes() {
      if (this.amount > 1000) {
        return this.$buefy.modal.open({
          parent: this,
          component: _DialogAlert.default,
          hasModalCard: true,
          canCancel: ['escape', 'outside'],
          props: {
            title: 'Confirmar',
            message: 'Você está solicitando a geração de mais que 1000 tags, por isso a listagem poderá demorar alguns minutos para atualizar.',
            confirmText: 'Gerar',
            onConfirm: this.generateCodes,
            type: 'is-warning'
          }
        });
      }
      this.generateCodes();
    },
    generateCodes: function () {
      var _generateCodes = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var data;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return this.generateIdentifiers({
                amount: this.amount,
                isFlag: this.generateIsFlag
              });
            case 1:
              data = _context2.v;
              if (data) {
                this.amount = null;
              }
              this.fetchAllIdentifiers(this.pageCurrent);
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function generateCodes() {
        return _generateCodes.apply(this, arguments);
      }
      return generateCodes;
    }(),
    preparesChange: function preparesChange(item) {
      var self = this;
      var itemChange = _.cloneDeep(item);
      self.typeServiceEdit = itemChange;
      self.showModal = true;
    },
    verifyDelete: function verifyDelete(item) {
      var self = this;
      self.dialogDelete = self.$buefy.modal.open({
        parent: self,
        component: _DialogAlert.default,
        hasModalCard: true,
        canCancel: ['escape', 'outside'],
        props: {
          title: self.$t('pages.stock.delete_dialog_title'),
          message: self.$t('pages.stock.delete_dialog_message'),
          confirmText: 'Excluir',
          onConfirm: self.deleteProduct,
          product: item,
          type: 'is-danger'
        }
      });
    },
    deleteProduct: function () {
      var _deleteProduct = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(row) {
        var res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return this.deleteInventory(row.id);
            case 1:
              res = _context3.v;
              if (res) {
                this.fetchAllIdentifiers();
                this.modalEditProduct.close();
              }
            case 2:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function deleteProduct(_x) {
        return _deleteProduct.apply(this, arguments);
      }
      return deleteProduct;
    }(),
    updateService: function () {
      var _updateService = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var self, _t;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              self = this;
              self.setLoading();
              _context4.p = 1;
              _context4.n = 2;
              return self.saveNewScheduling(self.scheduling);
            case 2:
              self.setLoading(false);
              self.$buefy.toast.open({
                message: 'Agendamento alterado com sucesso!',
                duration: 5000,
                type: 'is-success'
              });
              self.getServicesRest();
              _context4.n = 4;
              break;
            case 3:
              _context4.p = 3;
              _t = _context4.v;
              self.$buefy.toast.open({
                duration: 5000,
                message: "Ocorreu um erro ao tentar modificar o registro",
                position: 'is-top',
                type: 'is-danger'
              });
              self.setLoading(false);
            case 4:
              return _context4.a(2);
          }
        }, _callee4, this, [[1, 3]]);
      }));
      function updateService() {
        return _updateService.apply(this, arguments);
      }
      return updateService;
    }(),
    printItems: function () {
      var _printItems = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var limit, params, data;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              if (!((this.checkAll || this.listPrint.length >= 10) && !this.emailDownload)) {
                _context5.n = 1;
                break;
              }
              return _context5.a(2, this.$buefy.toast.open({
                duration: 5000,
                message: "Informe seu endere\xE7o de e-mail!",
                position: 'is-top',
                type: 'is-danger'
              }));
            case 1:
              limit = 300;
              params = {
                checkAll: this.checkAll,
                codes: this.listPrint,
                email: this.emailDownload
              };
              if (!this.checkAll) {
                params.limit = limit;
              }
              _context5.n = 2;
              return this.downloadTagsIdentifiers(params);
            case 2:
              data = _context5.v;
              console.log('data: ', data);
              if (data) {
                this.allCheckedOption('markOff');
                this.fetchAllIdentifiers(this.pageCurrent);
              }
            case 3:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function printItems() {
        return _printItems.apply(this, arguments);
      }
      return printItems;
    }(),
    allCheckedOption: function allCheckedOption(type) {
      var _this2 = this;
      if (type === 'markOff') {
        this.listPrint = [];
        return;
      }
      this.identifiersList.data.map(function (item) {
        if (!_this2.listPrint.find(function (i) {
          return i === item;
        }) && item.url) {
          _this2.listPrint.push(item);
        }
      });
    }
  })
};